module.exports = __webpack_public_path__ + "static/media/ecom.998a1526.svg";